import { z } from "zod";
import { dmaFormulationDtoSchema } from "../dma-formulation";
export const dmaInitialGuessesHintDtoSchema = z.object({
    formulation: dmaFormulationDtoSchema,
    parameters: z.record(z.number()),
});
